module.exports = __webpack_public_path__ + "img/atomic_04.6ad6e921.png";